import {
    get_utenti,
    create_utente,
    update_utente,
    reset_password_utente,
    abilita_utente,
    disabilita_utente,
    genera_embed_token,
    revoca_embed_token,
} from "@/api/api.utenti.js";

const utenti = {
    namespaced: true,

    state: {
        lista: [],
    },

    mutations: {
        SET_LISTA: (state, lista) => { state.lista = lista; },
    },

    actions: {
        carica({ commit }) {
            return new Promise((resolve, reject) => {
                get_utenti().then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salva({ dispatch }, { id, dati }) {
            const call = id ? update_utente(id, dati) : create_utente(dati);
            return new Promise((resolve, reject) => {
                call.then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        resetPassword(_ctx, { id, nuovaPassword }) {
            return reset_password_utente(id, nuovaPassword);
        },

        abilita({ dispatch }, { id }) {
            return new Promise((resolve, reject) => {
                abilita_utente(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        disabilita({ dispatch }, { id }) {
            return new Promise((resolve, reject) => {
                disabilita_utente(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        // A differenza di abilita/disabilita, qui il chiamante ha bisogno del token
        // aggiornato SUBITO dopo il resolve (per mostrarlo nel dialog): "carica" va
        // quindi atteso prima di risolvere, non solo lanciato in background.
        async generaEmbedToken({ dispatch }, { id }) {
            const resp = await genera_embed_token(id);
            await dispatch("carica");
            return resp;
        },

        async revocaEmbedToken({ dispatch }, { id }) {
            const resp = await revoca_embed_token(id);
            await dispatch("carica");
            return resp;
        },
    },

    getters: {
        lista: state => state.lista,
    },
};

export default utenti;
